import styled, { css } from 'styled-components';

import { Checkbox } from '@xsolla/ui-core';

export const DataWrapper = styled.div`
  margin-bottom: 32px;
`;

export const UserDataTitle = styled.h2`
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 8px;
`;

export const UserDataSubtitle = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 8px;
`;

export const UserDataFormTitle = styled.p`
  ${(p) => p.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 8px;
`;

export const NotificationWrapper = styled.div`
  margin-bottom: 32px;
`;

const inputReadonlyStyle = css`
  :checked {
    border-color: ${(props) => props.theme.colors.stroke};
    background-color: ${(props) => props.theme.colors.stroke};
  }

  :hover {
    border-color: ${(props) => props.theme.colors.stroke};
  }
`;

export const StyledCheckbox = styled(Checkbox)<{ isRequired: boolean }>`
  ${(props) => props.isRequired && inputReadonlyStyle}
`;

export const CheckBoxPill = styled.p`
  margin-left: 24px;
  font-size: 12px;
  line-height: 24px;
  font-family: Mono, sans-serif;
  background-color: ${(props) => props.theme.colors.overlay};
  color: ${(props) => props.theme.colors.disabled};
  display: inline-block;
  padding: 0 8px 0;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 189px;
`;
